/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minValue: NonNullable<unknown>, maxValue: NonNullable<unknown> }} Keen_Soft_Panda_RestInputs */

const en_keen_soft_panda_rest = /** @type {(inputs: Keen_Soft_Panda_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From ${i?.minValue}% to ${i?.maxValue}%`)
};

const de_keen_soft_panda_rest = /** @type {(inputs: Keen_Soft_Panda_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Von ${i?.minValue}% bis ${i?.maxValue}%`)
};

/**
* | output |
* | --- |
* | "From {minValue}% to {maxValue}%" |
*
* @param {Keen_Soft_Panda_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_soft_panda_rest = /** @type {((inputs: Keen_Soft_Panda_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Soft_Panda_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_soft_panda_rest(inputs)
	return de_keen_soft_panda_rest(inputs)
});